import React from 'react'

const ShareIcon = (
  <>
    {/* <path
      d="M11.3258 13.0238L22.8496 1.5"
      stroke="#B8A6C9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4687 1.5H22.8496V9.88095"
      stroke="#B8A6C9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.23056 4.64282H2.94485C2.38916 4.64282 1.85622 4.86357 1.46329 5.2565C1.07036 5.64944 0.849609 6.18237 0.849609 6.73806V21.4047C0.849609 21.9604 1.07036 22.4933 1.46329 22.8863C1.85622 23.2792 2.38916 23.5 2.94485 23.5H17.6115C18.1672 23.5 18.7001 23.2792 19.0931 22.8863C19.486 22.4933 19.7068 21.9604 19.7068 21.4047V15.119"
      stroke="#B8A6C9"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    /> */}
  </>
)

export default ShareIcon
